import { ajax } from '@/api/ajax';

export interface WiPageReq {
  /**
   * epc车型
   */
  modelCode?: string;
  currentPage?: number;
  size?: number;
  /**
   * 工时小类编码
   */
  smallCategoryCode?: string;
  /**
   * 工时编码
   */
  wiCode?: string;
  /**
   * 工时编码
   */
  wiName?: string;
}

export interface PageWiPageResp {
  countId?: string;
  current?: number;
  hitCount?: boolean;
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  pages?: number;
  records?: WiPageResp[];
  searchCount?: boolean;
  size?: number;
  total?: number;
}
export interface OrderItem {
  asc?: boolean;
  column?: string;
}
export interface WiPageResp {
  /**
   * 故障部位编码
   */
  faultPartCode?: string;
  /**
   * 故障部位名称
   */
  faultPartName?: string;
  /**
   * 工时大类编码
   */
  largeCategoryCode?: string;
  /**
   * 工时大类名称
   */
  largeCategoryName?: string;
  /**
   * 备件编码
   */
  partNo?: string;
  /**
   * 国家/地区
   */
  region?: string;
  /**
   * 国家/地区
   */
  regionName?: string;
  /**
   * 备注
   */
  remark?: string;
  /**
   * 车系编码
   */
  saleCarSeriesCode?: string;
  /**
   * 车系
   */
  saleCarSeriesName?: string;
  /**
   * 车型编码
   */
  saleCarTypeCode?: string;
  /**
   * 车型
   */
  saleCarTypeName?: string;
  /**
   * 工时小类编码
   */
  smallCategoryCode?: string;
  /**
   * 工时小类名称
   */
  smallCategoryName?: string;
  wiCarId?: number;
  /**
   * 工时编码
   */
  wiCode?: string;
  /**
   * 工时名称
   */
  wiName?: string;
  /**
   * 工时数量
   */
  wiQty?: number;
}

export function getWorkHourList(data: WiPageReq) {
  return ajax<PageWiPageResp>({
    url: '/api/tis/web/wi/listByPage',
    method: 'post',
    data: data
  });
}
